import React, { useState } from 'react'

import CTA from '@f/elements/CTA'

const RefreshMapCTA = ({
  applyQuery,
  showApplyQueryCTA,
  displayingFilters,
  isBottom
}) => {
  const [loader, setLoader] = useState(false)

  const handleClick = () => {
    setLoader(true)

    setTimeout(() => {
      applyQuery()
      setLoader(false)
    }, 500)
  }

  return (
    <span
      className={`[ f-pos-ab ] MapView-update-cta-wrap ${
        isBottom ? 'is-bottom' : ''
      } ${loader ? 'is-loading' : ''} ${
        showApplyQueryCTA ? 'is-shown' : 'is-hidden'
      } ${displayingFilters ? 'has-expanded-filters' : ''}`}>
      <CTA
        type='block-secondary'
        tag='button'
        className='[ f-p-v-010 f-p-h-020 f-pos-rel ] MapView-map-cta'
        onClick={handleClick}>
        <span className='MapView-map-cta-loader' />
        <span className='MapView-map-cta-text'>Ergebnisse aktualisieren</span>
      </CTA>
    </span>
  )
}

export default RefreshMapCTA
